import { render } from "./MessageOut.vue?vue&type=template&id=d64ee444"
import script from "./MessageOut.vue?vue&type=script&lang=ts"
export * from "./MessageOut.vue?vue&type=script&lang=ts"
script.render = render

export default script